<h1 mat-dialog-title>Update Attributes for {{ data.itemCode }}</h1>
<div
  class="flex flex-col justify-start items-stretch"
  mat-dialog-content
  [formGroup]="form"
  testId="Update-attribute-value-form"
>
  <div
    class="flex flex-col justify-start items-stretch"
    *ngFor="let attribute of data.attributes; let index = index"
    formArrayName="attributes"
    testId="bulk-update-attribute-{{ attribute.id }}"
  >
    <h2>Updating {{ attribute.name }}</h2>
    <app-key-value-pair
      key="attribute-current-value-{{ attribute.id }}"
      name="Current value"
      [value]="attribute.latest_value | attributeValue : attribute.data_type"
    ></app-key-value-pair>
    <app-key-value-pair
      key="attribute-last-updated-{{ attribute.id }}"
      name="Last Updated"
      [value]="attribute.current_value | attributeValueTimestampUser | async"
    ></app-key-value-pair>
    <ng-container [formGroupName]="index">
      <app-attribute-value-input
        testId="attribute-new-value-{{ attribute.id }}"
        formControlName="value"
        label="New Value"
        [type]="attribute.data_type"
      ></app-attribute-value-input>
    </ng-container>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close testId="cancel-update-attribute-dialog">
    Cancel
  </button>
  <button
    mat-button
    color="primary"
    [disabled]="form.invalid"
    (click)="save()"
    testId="save-update-attribute-dialog"
  >
    Update
  </button>
</div>
